/**
 * オーバーレイ定義の取得（EP-2）。
 *
 * マニフェストの `urls.overlays`（署名 URL）から 1 冊分をまとめて取り、ページ番号で束ねる。
 * 取得失敗は例外にせず空で縮退する — オーバーレイが出ないことより、読書が止まらないことを
 * 優先する（`user-data/comments.ts` と同じ方針）。
 *
 * 許可外ページ（EP-5）の分はサーバが返さないので、ここでの絞り込みは要らない。
 */
import type { OverlayItem } from './registry';

interface OverlayResponse {
  items?: OverlayItem[];
}

/** ページ番号 → そのページのオーバーレイ（z 昇順・サーバの並びのまま）。 */
export type OverlaysByPage = ReadonlyMap<number, readonly OverlayItem[]>;

export async function fetchOverlays(url: string, signal?: AbortSignal): Promise<OverlaysByPage> {
  const byPage = new Map<number, OverlayItem[]>();
  let data: OverlayResponse | null = null;
  try {
    const response = await fetch(url, {
      credentials: 'same-origin',
      ...(signal ? { signal } : {}),
    });
    if (response.ok) data = (await response.json()) as OverlayResponse;
  } catch {
    return byPage; // 中断・ネットワーク断でも読書を止めない
  }

  for (const item of data?.items ?? []) {
    const list = byPage.get(item.page);
    if (list) list.push(item);
    else byPage.set(item.page, [item]);
  }
  return byPage;
}
